import React, { useCallback, useContext, useEffect } from 'react';
import {
  CalculationTargetResourceType,
  CalculatorContext,
  getOrderedOptions,
  VariableContext,
} from '../../../../../../services/common/CalculatorUtils';
import _ from 'lodash';
import CalculatorSelectInput from '../../calculatorInputs/CalculatorSelectInput';
import i18next from 'i18next';
import useStyles from '../../../../../../style/js-style/containers/administration/calculator/CalculatorDialogStyle';
import { useFormContext } from 'react-hook-form';

const ContextModels = ({ fieldName, readOnly = false }) => {
  const { classes } = useStyles();
  const { contextModels } = useContext(CalculatorContext);
  const formMethods = useFormContext();
  const { getValues, setValue, clearErrors, watch } = formMethods;
  const { onVariableChangeCallBack, currentVariable } = useContext(
    VariableContext
  );
  const selectedModels = watch('targetResourceKeys');
  const targetResourceType = watch('targetResourceType');
  const modelListField = watch(fieldName);

  const onTargetFieldContextModelChange = useCallback(() => {
    if (!getValues(`${fieldName}.field`) || (getValues(`${fieldName}.field`) === '')) {
      setValue(`${fieldName}.field`, '');
      clearErrors(`${fieldName}.field`, '');

      setValue(`${fieldName}.field_type`, '');
      clearErrors(`${fieldName}.field_type`, '');
    }
  }, [fieldName, setValue, clearErrors, getValues]);

  const parsedModels = getOrderedOptions(
    contextModels.map((model) => {
      return {
        label: model.name,
        value: model.id,
      };
    })
  );

  useEffect(() => {
    if (targetResourceType === CalculationTargetResourceType.CONTEXT && selectedModels.length) {
      setValue(`${fieldName}.context_model_id`, selectedModels[0]);
    }
  }, [selectedModels, fieldName, targetResourceType, setValue]);

  useEffect(() => {
    if (targetResourceType === CalculationTargetResourceType.CONTEXT && selectedModels.length) {
      const variables = getValues('variables');
      const updatedVariable = variables.find(
        (v) => v.id === currentVariable.id
      );
      onTargetFieldContextModelChange();
      onVariableChangeCallBack(updatedVariable, 'context_model_id');
    }
    // eslint-disable-next-line
  }, [modelListField]);

  return (
    <>
      <div className={classes.variableDivider}> /</div>

      {!_.isEmpty(contextModels) && (
        <CalculatorSelectInput
          fieldName={`${fieldName}.context_model_id`}
          label={``}
          isRequired
          placeholder={i18next.t(
            `calculator.dialog.create.placeholder.selectValue`
          )}
          options={parsedModels}
          onChange={(newValue) => {
            onTargetFieldContextModelChange(newValue);
            onVariableChangeCallBack(currentVariable, 'context_model_id');
          }}
          validate={() => null}
          variant="standard"
          labelVariant="standard"
          className={classes.inputPathVariableItem}
          disabled={targetResourceType === CalculationTargetResourceType.CONTEXT || readOnly}
        />
      )}
    </>
  );
};

export default ContextModels;
